import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AvailableCaches } from '../state/_models/ignatius.models';

/**
 * ****************************** WARNING ******************************
 * This is a experimental feature. Please don't alter the values for now
 * Doing so may break current flow of application
 * *********************************************************************
 */
@Injectable({
  providedIn: 'root',
})
export class CacheService {
  /**
   * Caching states
   */
  readonly cachingState = {
    [AvailableCaches.QUERY_REPORT]: false,
    [AvailableCaches.CONDITIONAL_QUERY_REPORT]: false,
    [AvailableCaches.DROPDOWN]: false,
    [AvailableCaches.USER_APPLICATIONS]: false,
    [AvailableCaches.COMPANIES]: false,
    [AvailableCaches.APPLICATION_DATA]: false,
    [AvailableCaches.NAVIGATION]: false,
    [AvailableCaches.FIELDS]: false,
    [AvailableCaches.FIELD_TYPES]: false,
    [AvailableCaches.REPORT]: false,
    [AvailableCaches.RELATION]: false,
    [AvailableCaches.APPLICATION_USERS]: false,
    [AvailableCaches.ROLES]: false,
    [AvailableCaches.ROLE_DETAIL]: false,
    [AvailableCaches.PAGES]: false,
    [AvailableCaches.LAYOUTS]: false,
    [AvailableCaches.NOTIFICATION_LOGS]: false,
    [AvailableCaches.PROCESS]: false,
    [AvailableCaches.THEMES]: false,
    [AvailableCaches.DASHBOARDS]: false,
    [AvailableCaches.SUPERSETDASHBOARDS]: false,
    [AvailableCaches.METABASEDASHBOARDS]: false,
    [AvailableCaches.TABLES]: false,
    [AvailableCaches.ALLTABLES]: false,
    [AvailableCaches.FORM]: false,
    [AvailableCaches.SUMMARY_FIELDS]: false,
    [AvailableCaches.DATABASE_REPORTS]: false,
    [AvailableCaches.SUMMARY_REPORTS]: false,
    [AvailableCaches.IMPORTS]: false,
    [AvailableCaches.COPY_APPS]: false,
    [AvailableCaches.PURGES]: false,
    [AvailableCaches.NOTIFICATION]: false,
    [AvailableCaches.CLIENTS]: false,
    [AvailableCaches.TEMPLATES]: false,
  };

  viewModeDatasetState:any = new BehaviorSubject(Math.random());

  constructor() {}

  /**
   * Get cache state
   * @param name name of the cache
   */
  getCacheState = (name: AvailableCaches) => this.cachingState[name];
}
